import React, { ReactElement, ReactNode } from "react";
import cmpLogo from "../../images/cmp_logo.png";

/**
 * Full-screen page with the black logo header, for screens that show before
 * or without the dashboard (offline design C, error pages that cannot load
 * the dashboard). Approved canvas, Moeen Oct 27 2026.
 */
const StandalonePage = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => (
  <div className="flex min-h-screen w-full flex-col bg-[#F7F7F8] text-black">
    <header className="flex h-[72px] flex-none items-center bg-[#0A0A0A] px-6 md:px-10">
      <img
        src={cmpLogo}
        alt="Chamber Member Pro"
        className="block h-auto w-[150px]"
      />
    </header>
    <main className="flex flex-1 items-center justify-center px-4 py-10">
      {children}
    </main>
    <footer className="flex-none pb-7 text-center text-[12px] tracking-[0.06em] text-[#727272]">
      MANAGE | ENGAGE | AUTOMATE
    </footer>
  </div>
);

export default StandalonePage;
